import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from "@angular/core";
import { BvSpace, spaceVar } from "./types";

/**
 * Explicit spacer for cases where bv-stack/bv-cluster gap isn't enough,
 * or when a non-flex layout needs a token-driven gap.
 *
 * - `axis="block"` (default): consumes vertical space.
 * - `axis="inline"`: consumes horizontal space.
 */
@Component({
    selector: "bv-spacer",
    template: "",
    styles: [
        `
      :host {
        display: block;
        flex-shrink: 0;
      }
    `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BvSpacerComponent {
  @Input() size: BvSpace = "4";
  @Input() axis: "block" | "inline" = "block";

  @HostBinding("style.height")
  get heightStyle(): string | null {
    return this.axis === "block" ? spaceVar(this.size) : null;
  }

  @HostBinding("style.width")
  get widthStyle(): string | null {
    return this.axis === "inline" ? spaceVar(this.size) : null;
  }
}
